/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LoyaltyAccount } from './LoyaltyAccount';
import {
    LoyaltyAccountFromJSON,
    LoyaltyAccountFromJSONTyped,
    LoyaltyAccountToJSON,
    LoyaltyAccountToJSONTyped,
} from './LoyaltyAccount';
import type { CardProgramSummary } from './CardProgramSummary';
import {
    CardProgramSummaryFromJSON,
    CardProgramSummaryFromJSONTyped,
    CardProgramSummaryToJSON,
    CardProgramSummaryToJSONTyped,
} from './CardProgramSummary';
import type { CurrencyAmount } from './CurrencyAmount';
import {
    CurrencyAmountFromJSON,
    CurrencyAmountFromJSONTyped,
    CurrencyAmountToJSON,
    CurrencyAmountToJSONTyped,
} from './CurrencyAmount';

/**
 * 
 * @export
 * @interface LoyaltyAccountsResponse
 */
export interface LoyaltyAccountsResponse {
    /**
     * 
     * @type {Array<LoyaltyAccount>}
     * @memberof LoyaltyAccountsResponse
     */
    items?: Array<LoyaltyAccount>;
    /**
     * Total number of loyalty accounts
     * @type {number}
     * @memberof LoyaltyAccountsResponse
     */
    accountTotal?: number;
    /**
     * Present on extended responses. Empty is a successful empty result; absence indicates a producer without summary support. Raw items remain the current user's accounts.
     * @type {Array<CardProgramSummary>}
     * @memberof LoyaltyAccountsResponse
     */
    cardProgramSummaries?: Array<CardProgramSummary>;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof LoyaltyAccountsResponse
     */
    totalCashValue?: CurrencyAmount;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof LoyaltyAccountsResponse
     */
    pointsUpdateTotal?: CurrencyAmount;
}

/**
 * Check if a given object implements the LoyaltyAccountsResponse interface.
 */
export function instanceOfLoyaltyAccountsResponse(value: object): value is LoyaltyAccountsResponse {
    return true;
}

export function LoyaltyAccountsResponseFromJSON(json: any): LoyaltyAccountsResponse {
    return LoyaltyAccountsResponseFromJSONTyped(json, false);
}

export function LoyaltyAccountsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoyaltyAccountsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(LoyaltyAccountFromJSON)),
        'accountTotal': json['account_total'] == null ? undefined : json['account_total'],
        'cardProgramSummaries': json['card_program_summaries'] == null ? undefined : ((json['card_program_summaries'] as Array<any>).map(CardProgramSummaryFromJSON)),
        'totalCashValue': json['total_cash_value'] == null ? undefined : CurrencyAmountFromJSON(json['total_cash_value']),
        'pointsUpdateTotal': json['points_update_total'] == null ? undefined : CurrencyAmountFromJSON(json['points_update_total']),
    };
}

export function LoyaltyAccountsResponseToJSON(json: any): LoyaltyAccountsResponse {
    return LoyaltyAccountsResponseToJSONTyped(json, false);
}

export function LoyaltyAccountsResponseToJSONTyped(value?: LoyaltyAccountsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(LoyaltyAccountToJSON)),
        'account_total': value['accountTotal'],
        'card_program_summaries': value['cardProgramSummaries'] == null ? undefined : ((value['cardProgramSummaries'] as Array<any>).map(CardProgramSummaryToJSON)),
        'total_cash_value': CurrencyAmountToJSON(value['totalCashValue']),
        'points_update_total': CurrencyAmountToJSON(value['pointsUpdateTotal']),
    };
}

